import { Divider, Paper, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { no_img } from "../../assets";
import { AppContext } from "../../App";

const ProdWidget = ({ handleCart, prod }) => {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);

  const prodCls = {
    borderTopLeftRadius: "0.8rem",
    borderTopRightRadius: "0.8rem",
    height: "100px",
    width: "100%",
    objectFit: "cover",
    borderBottom: "1px solid var(--grayLight-color)",
  };

  return (
    <Paper
      onClick={() => handleCart(prod)}
      className="br-8 shadow-xs c-pointer h-100pr bg-white"
      sx={{ userSelect: "none" }}
    >
      <img
        style={prodCls}
        className="img-fluid obj-contain"
        src={prod.imgs.length > 0 ? prod.imgs[0].imgUrl : no_img}
        alt="prod-img"
      />
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "15px" }}
        className="p-10 pb-0 gray-color"
      >
        {prod.label}
        <Divider />
        <div className="d-grid">
          <span className="fs-12 fw-6">
            {t("price")}:{" "}
            {(settings && settings.curSymbol) +
              " " +
              prod.sellPrice.toFixed(settings.decimal)}
          </span>

          <span
            className={`fs-12 fw-6 ${prod.inventory <= 0 && " error-color"}`}
          >
            {t("stock")}: {prod.inventory}
          </span>
        </div>
      </Typography>
    </Paper>
  );
};

export default ProdWidget;
